import {Button} from "@mui/material";
import {KeyboardReturn} from "@mui/icons-material";

export default function InsertLineBreakButton(props: {
	onClick: () => void
}) {

	return (
		<>
			<Button
				onClick={props.onClick}
				variant={"outlined"}
				size={"small"}
				startIcon={<KeyboardReturn/>}
			>
				Line Break
			</Button>
		</>
	)
}
